import { graphql } from 'gatsby';
import { getKey } from '../../../helpers';

/**
 * Chart widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the strings
 * @returns {Object} widget definition
 */
export const chart = function chart(props, locale) {
  return {
    widgetType: 'chart',
    key: getKey(props, 'key'),
    mapImage: getKey(props, 'mapImage.url'),
    locale,
  };
};

/**
 * Chart widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the strings
 * @returns {Object} widget definition
 */
export default function chartprovider(props, locale) {
  const key = getKey(props, 'key');

  return {
    locale,
    chartId: key
  };
}

/**
 * GraphQL query
 */
export const query = graphql`
  fragment Chart on StrapiWidgetrels {
    chart {
      key: id
      widgetPosition
    }
  }
`;
